// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {CSSProperties, useMemo} from 'react';
import styles from './spacer.module.less';

interface i_spacer {
    size?: number;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
}
export const Spacer = (props: i_spacer)=>{
    const {size, xs, sm, md, lg, xl} = props;
    if (size === undefined)
        return <div className={styles.spacer}></div>;
    const style = useMemo(()=>{
        return {
            '--size': size+'px',
            '--xl': (xl ?? size)+'px',
            '--lg': (lg ?? xl ?? size)+'px',
            '--md': (md ?? lg ?? xl ?? size)+'px',
            '--sm': (sm ?? md ?? lg ?? xl ?? size)+'px',
            '--xs': (xs ?? sm ?? md ?? lg ?? xl ?? size)+'px',
        } as CSSProperties;
    }, [size, xs, sm, md, lg, xl]);
    return <div className={styles.custom_spacer} style={style}></div>;
};
